import { render, staticRenderFns } from "./ViewOrEditCNICRegistrar.vue?vue&type=template&id=28fc4eae"
import script from "./ViewOrEditCNICRegistrar.vue?vue&type=script&lang=js"
export * from "./ViewOrEditCNICRegistrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports